import { motion, useReducedMotion } from 'motion/react';

import { collapseVariants, SECTION_TRANSITION } from './motion';

export function MotionRow({ children }: { children: React.ReactNode }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      layout={!reduce}
      variants={collapseVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={reduce ? { duration: 0 } : SECTION_TRANSITION}
      className="overflow-hidden"
    >
      {children}
    </motion.div>
  );
}
